<template>
  <div id="app">
    <Header></Header>
    <div>
      <b-alert
        :variant="root_alert_message.variant"
        :show="root_alert_message.show"
        @dismissed="hide_alert_message"
        >{{ root_alert_message.alert_message }}</b-alert
      >

      <b-modal ref="modal_image_view" centered hide-footer hide-header>
        <p class>
          <strong>Delivered at:</strong>
          {{ root_image_view.pod_at }}
        </p>

        <p class>
          <strong>Number of order :</strong>
          {{ root_image_view.order_ids.length }}
        </p>

        <div class="container-order_ids">
          <span
            class="order_id_badge"
            :key="oid_key"
            v-for="(oid_val, oid_key) in root_image_view.order_ids"
            >{{ oid_val }}</span
          >
        </div>

        <div>
          <img style="width: 100%;" :src="root_image_view.image_url" />
        </div>
      </b-modal>

      <b-modal ref="modal_message" centered hide-footer hide-header>
        <div class="d-block">{{ root_modal_message.message_content }}</div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            :variant="`outline-${root_modal_message.variant}`"
            @click="hide_modal_message"
            >OK</b-btn
          >
        </div>
      </b-modal>

      <b-modal
        ref="modal_auto_route_review"
        title="Route Auto-Assigned — Please Review"
        hide-footer
        size="xl"
      >
        <p class="text-muted" style="font-size: 13px;">
          The routes below were assigned automatically and have not been
          verified by staff. Please double check them, and adjust any that
          are wrong.
        </p>
        <b-table
          small
          striped
          outlined
          :items="root_auto_route_review.items"
          :fields="auto_route_review_fields"
        >
          <template v-slot:cell(source)="data">
            <b-badge
              :variant="data.item.source === 'auto_learned' ? 'success' : 'info'"
              >{{ data.item.source }}</b-badge
            >
          </template>

          <template v-slot:cell(route)="data">
            <b-form-select
              size="sm"
              :value="data.item.route"
              :options="auto_route_review_route_options"
              @change="onAutoRouteChange(data.item, $event)"
            />
          </template>
        </b-table>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-secondary"
            @click="hide_auto_route_review"
            >OK</b-btn
          >
        </div>
      </b-modal>
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "App",
  provide: {
    API_HOST: process.env.VUE_APP_API_HOST,
    NODEJS_API_URL: process.env.NODEJS_API_URL,
    TABLE_LIMIT: 50,
    PAGING_LIMIT: 10,
    is_login: localStorage.getItem("user") ? true : false,
    ERROR_MESSAGES: {
        integer: "Must be an integer",
        alpha: "Alphanumeric characters only.",
        email: "Must be a valid email address.",
        minLength8: "Must have a length no less than 8.",
        minLength0: "Must be greater than 0.",
        required: "Required field.",
        numeric: "Must be a number",
        decimal: "Must be a number",
        overlapDate: "Date range cannot be overlapped",
        password_not_match: "Password not matched",
    },
    DEFAULT_ROWS_PER_PAGE: 50
  },
  components: {
    Header
  },
  data() {
    return {
      root_modal_message:{
        message_content: '',
        variant: 'success'
      },
      root_alert_message: {
        alert_message: "",
        variant: "",
        show: false
      },
      root_image_view: {
        image_url: "",
        order_ids: [],
        pod_at: ""
      },
      root_image_view_cntdown: 0,
      root_auto_route_review: {
        items: []
      },
      auto_route_review_fields: [
        { key: "order_number", label: "Order #" },
        { key: "address", label: "Address", tdClass: "auto_route_review_address_cell" },
        { key: "route", label: "Route Assigned" },
        { key: "source", label: "Source" },
        { key: "reliability", label: "Confidence" }
      ],
      auto_route_review_route_options: []
    };
  },
  mounted() {
    // alert message
    this.$eventHub.$on("show_alert_message", data => {
      this.root_alert_message.variant = data.variant;
      this.root_alert_message.alert_message = data.alert_message;
      this.root_alert_message.show = true;

      setTimeout(() => {
        this.root_alert_message = {
          alert_message: "",
          variant: "",
          show: false
        };
      }, 5000);

    });

    // modal message
    // this.$eventHub.$emit("show_modal_message", {
    //   message_content: 'XXX'
    // });

    this.$eventHub.$on("show_modal_message", data => {
      this.root_modal_message.message_content = data.message_content;
      this.root_modal_message.variant = data.variant;
      this.$refs.modal_message.show();
    });

    // modal image view
    this.$eventHub.$on("show_image_view", data => {
      this.root_image_view.image_url = data.image_url;
      this.root_image_view.order_ids = data.order_ids;
      this.root_image_view.pod_at = data.pod_at;
      this.$refs.modal_image_view.show();
    });

    this.$eventHub.$on("hide_image_view", () => {
      this.root_image_view = {
        image_url: "",
        order_ids: [],
        pod_at: ""
      };
      this.$refs.modal_image_view.hide();
    });

    // auto route assignment review
    this.$eventHub.$on("show_auto_route_review", async data => {
      this.root_auto_route_review.items = data.items;

      if (!this.auto_route_review_route_options.length) {
        let routes_response = await this.$http({
          method: "POST",
          baseURL: `${process.env.VUE_APP_API_HOST}`,
          url: "tracking_route_get.php",
          data: {
            client_id: this.$store.state.user_obj.client_id
          }
        });
        this.auto_route_review_route_options = (
          routes_response.data.tracking_routes || []
        ).map(r => ({
          value: r.route_name,
          text: r.route_name
        }));
      }

      this.$refs.modal_auto_route_review.show();
    });
  },
  methods: {
    hide_alert_message() {
      this.root_alert_message = {
        alert_message: "",
        variant: "",
        show: false
      };
    },

    hide_modal_message() {
      this.$refs.modal_message.hide();
      this.root_modal_message = {
        message_content: '',
        variant: 'success'
      };
    },

    hide_auto_route_review() {
      this.$refs.modal_auto_route_review.hide();
      this.root_auto_route_review = { items: [] };
    },

    async onAutoRouteChange(item, new_route) {
      if (!new_route || new_route === item.route) {
        return;
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${process.env.VUE_APP_API_HOST}`,
        url: "auto_route_review_correct.php",
        data: {
          order_number: item.order_number,
          route: new_route,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      if (response.data.status === "success") {
        item.route = new_route;
        item.source = "manual";
        item.reliability = "HIGH";
      }
    }
  }
};
</script>

<style lang="scss">
@import "./assets/styles/app.scss";

.btn-action {
  min-width: 100px;
}

.btn-action-lg {
  min-width: 130px;
}

.width-fit {
  width: 1%;
}

.ani-opacity-fade {
  transition: opacity 0.3s ease-in-out;
  -moz-transition: opacity 0.3s ease-in-out;
  -webkit-transition: opacity 0.3s ease-in-out;
}

.txt_camelcase {
  text-transform: capitalize;
}

.order_id_badge {
  border: 1px solid #cacaca;
  border-radius: 5px;
  padding: 5px 10px;
}

.container-order_ids {
  margin-bottom: 10px;
}

.navbar-dark .navbar-nav .nav-link.router-link-active {
  color: rgba(255, 255, 255, 0.9);
}

.center_align {
  text-align: center;
}

.text-nowrap {
  white-space: nowrap;
}

.dot_container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dot_expired,
.dot_critical_level,
.dot_green {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #00e570;
  margin-top: 5px;
}

.dot_expired.red_light,
.dot_critical_level.red_light,
.dot_red {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #db5252;
  margin-top: 5px;
}

.dot_critical_level.yellow_light,
.dot_yellow{
  background-color: #ffd10f;
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-top: 5px; 
}

.dot_white {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: white;
  border-color: #cacaca;
  margin-top: 5px;
}

.dot_grey {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #dadada;
  border-color: #cacaca;
  margin-top: 5px;
}

.dot_gols {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #d47f46;
  border-color: #cacaca;
  margin-top: 5px;
}

.dot_client {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #0b1d2d;
  border-color: #cacaca;
  margin-top: 5px;
}

.cusor_pointer{
  cursor: pointer;
}

.auto_route_review_address_cell {
  font-size: 12px;
  white-space: normal;
}

.d-block{
  white-space: pre-line;
}

.td_maxwidth150{
  max-width: 150px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.td_maxwidth250{
  max-width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-ellipsis{
text-overflow: ellipsis;
    overflow: hidden;
}

ul{
  padding-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue